"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontFamily = void 0;
const extension_font_family_1 = require("@tiptap/extension-font-family");
// We had to add " " around the font family name to support font families with numbers and special characters.
// Without the quotes, we were unable to apply font families like Source Sans 3
exports.FontFamily = extension_font_family_1.FontFamily.extend({
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontFamily: {
                        default: null,
                        parseHTML: (element) => element.style.fontFamily?.replace(/['"]+/g, ''),
                        renderHTML: (attributes) => {
                            if (!attributes.fontFamily) {
                                return {};
                            }
                            return {
                                style: `font-family: "${attributes.fontFamily}"`,
                            };
                        },
                    },
                },
            },
        ];
    },
});
//# sourceMappingURL=font-family.js.map